import type { HTMLProps, LegacyRef } from 'react';
import { forwardRef } from 'react';

function AccordionComponent(
  { children, multiple, ...props }: HTMLProps<HTMLUListElement>,
  ref: LegacyRef<HTMLUListElement>
) {
  return (
    <ul ref={ref} {...props} uk-accordion={multiple ? 'multiple: true' : ''}>
      {children}
    </ul>
  );
}

export default forwardRef(AccordionComponent);
